export default __webpack_public_path__ + "static/media/cancel-dark.2890f004.svg";